import {Signal} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {Router, Routes} from "@angular/router";
import {RolePermission} from "@menu-security";
import {unsavedPeriodGuard} from "../../services/guards/unsaved-guard";
import {getNestedRouteData} from "../../services/navigation/navigation.utils";

export const isRoughPlan = (): Signal<boolean> => toSignal(getNestedRouteData(({rough}) => rough == null ? null : rough === true), {initialValue: false});

export const CREATE = "create";

export function isRoughPlanCreation(router: Router): boolean {
    return router.url.includes("/rough-planning/create")
}

export const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        data: {rough: true},
        loadComponent: async () => import("./rough-planning-list/rough-planning-list.component").then(({RoughPlanningListComponent}) => RoughPlanningListComponent),
    },
    {
        path: CREATE,
        data: {permissions: [RolePermission.MealPlanModelWrite], rough: true},
        loadChildren: async () => import("../meal-plan-model/meal-plan-model-create/meal-plan-model-create.routes").then((MealPlanModelCreate) => MealPlanModelCreate.routes),
    },
    {
        path: "plan/:id",
        loadComponent: async () => import("../menu-planning/menu-planning-plan/menu-planning-plan.component").then(({MenuPlanningPlanComponent}) => MenuPlanningPlanComponent),
        canDeactivate: [unsavedPeriodGuard],
    },
    {
        path: "**",
        redirectTo: "",
    },
];
